document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("imageModal");
  const thumbs = document.querySelectorAll(".custom-thumb:not(#imageModal .custom-thumb)");
  const images = document.querySelectorAll(".custom-card:not(#imageModal .custom-card)");

  const thumbsSwipers = document.querySelectorAll('.thumbs-swiper');

  thumbsSwipers.forEach((swiperEl) => {
    new Swiper(swiperEl, {
      direction: 'vertical',
      slidesPerView: 'auto',
      freeMode: true,
      watchOverflow: true,
      mousewheel: true,
    });
  });

  const scrollToImage = (index, imagesList) => {
    imagesList[index]?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const resetThumbs = (thumbsList) => {
    thumbsList.forEach((thumb) => thumb.querySelector(".media--thumb")?.classList.remove("active-thumb"));
  };

  const highlightActiveThumb = (imagesList, thumbsList) => {
    const scrollPos = window.scrollY;
    imagesList.forEach((image, index) => {
      const { top, height } = image.getBoundingClientRect();
      const offsetTop = top + window.scrollY;
      const offsetBottom = offsetTop + height;

      if (scrollPos >= offsetTop - 200 && scrollPos < offsetBottom - 200) {
        resetThumbs(thumbsList);
        thumbsList[index].querySelector(".media--thumb")?.classList.add("active-thumb");
      }
    });
  };

  const setupThumbClickEvents = (thumbsList, imagesList) => {
    thumbsList.forEach((thumb, index) => {
      thumb.addEventListener("click", () => scrollToImage(index, imagesList));
    });
  };

  window.addEventListener("scroll", () => {
    highlightActiveThumb(images, thumbs);
  });

  setupThumbClickEvents(thumbs, images);

  if (modal) {
    const closeModalButton = modal.querySelector(".close");
    const modalThumbs = modal.querySelectorAll(".custom-thumb");
    const modalImages = modal.querySelectorAll(".custom-card");

    const toggleModal = (index = 0, isOpen = true) => {
      modal.style.display = isOpen ? "block" : "none";
      if (isOpen) {
        scrollToImage(index, modalImages);
      } else {
        scrollToImage(0, images);  
        resetThumbs(thumbs); 
        thumbs[0].querySelector(".media--thumb")?.classList.add("active-thumb");
      }
    };

    images.forEach((image, index) => {
      image.addEventListener("click", () => {
        toggleModal(index, true);
      });
    });

    closeModalButton?.addEventListener("click", () => toggleModal(0, false));
    window.addEventListener("click", (event) => {
      if (event.target === modal) toggleModal(0, false);
    });

    window.addEventListener("scroll", () => {
      highlightActiveThumb(modalImages, modalThumbs);
    });

    setupThumbClickEvents(modalThumbs, modalImages);
  }
});
